import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './GradePage.css';

const Grade10Page = () => {
  return (
    <div className="grade-page">
      <Navbar />
      
      <main className="main-content">
        <div className="grade-hero" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
          <div className="container">
            <h1>Grade 10 Resources</h1>
            <p>Senior Secondary Level 1 CBC Curriculum Materials</p>
          </div>
        </div>
        
        <div className="container">
          <div className="page-content">
            <h2>Coming Soon - Comprehensive Grade 10 Resources</h2>
            <p>This page is under development and will contain:</p>
            
            <div className="resources-grid">
              <div className="resource-card">
                <h3>Biology</h3>
                <p>Biological concepts and laboratory work</p>
              </div>
              
              <div className="resource-card">
                <h3>Chemistry</h3>
                <p>Chemical principles and experiments</p>
              </div>
              
              <div className="resource-card">
                <h3>Physics</h3>
                <p>Physical concepts and practicals</p>
              </div>
              
              <div className="resource-card">
                <h3>Mathematics</h3>
                <p>Advanced mathematical concepts</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Grade10Page;